export enum FilterParam {
  framework = 'framework',
}

export const FILTER_SECTIONS = []
